<template>
    <li class="tree-item">
        <template v-if="localItem[children] && localItem[children].length > 0">
            <font-awesome-icon
                :icon="open ? 'caret-down' : 'caret-right'"
                class="caret"
                @click="toggleSubTree"
            />
        </template>
        <template v-else>
            <span class="caret-spacer">&nbsp;</span>
        </template>
        <div class="criteria-box">
            <div class="meta">
                <p class="label">
                    {{meta.title}}
                    <b-button :id="'description-' + localItem.id" variant="link" size="sm">
                        <font-awesome-icon icon="info-circle" />
                    </b-button>
                </p>
                <p class="route small">{{localItem.criteria}}</p>
                <b-tooltip
                    :target="'description-' + localItem.id"
                    triggers="hover"
                >{{meta.description}}</b-tooltip>
            </div>
            <div class="options">
                <!--<input
                    type="checkbox"
                    class="referer"
                    v-for="checkboxValue in checkboxValues"
                    :key="checkboxValue"
                    :checked="handleRights(checkboxValue)"
                    :indeterminate.prop="handleIndeterminate(checkboxValue)"
                    :true-value="1"
                    :false-value="0"
                    @input="toggleSelect($event, checkboxValue)"
                />-->
                <b-button-group size="sm">
                    <b-button variant="primary" @click="toggleButton('read')">
                        Ansehen
                        <font-awesome-icon :icon="outputRight('read')" />
                    </b-button>
                    <b-button variant="danger" @click="toggleButton('write')">
                        Ändern
                        <font-awesome-icon :icon="outputRight('write')" />
                    </b-button>
                    <b-button variant="warning" @click="toggleButton('delete')">
                        Löschen
                        <font-awesome-icon :icon="outputRight('delete')" />
                    </b-button>
                </b-button-group>
            </div>
        </div>
        <ul class="sub-tree" v-if="localItem[children]" v-show="open">
            <TreeItem
                v-for="uItem in localItem[children]"
                :key="uItem.criteria"
                :item="uItem"
                :parent="handleParent()"
                @update="update"
            />
        </ul>
    </li>
</template>

<script>
import "./TreeItem.scss";

export default {
    name: "TreeItem",
    components: {},
    props: ["item", "rerender", "parent"],
    data() {
        return {
            open: true,
            localItem: this.item,
            children: "children",
            checkboxValues: ["read", "write", "delete"]
        };
    },
    computed: {
        meta() {
            const meta = {
                title: "Ohne Titel",
                description: "Beschreibung"
            };

            if (this.localItem.meta) {
                const json = JSON.parse(this.localItem.meta);
                Object.assign(meta, json);
            }
            return meta;
        }
    },
    methods: {
        toggleSubTree() {
            this.open = !this.open;
        },
        toggleSelect(event, referer) {
            const value = event.target.checked ? 1 : 0;
            this.localItem[referer] = value;
            this.$emit("update", this.localItem);
        },
        toggleButton(referer) {
            var currentVal = this.localItem[referer];
            if (currentVal === 1) {
                currentVal = 0;
            } else if (currentVal === 0) {
                currentVal = null;
            } else {
                currentVal = 1;
            }
            this.localItem[referer] = currentVal;
            this.$emit("update", this.localItem);
        },
        handleIndeterminate(referer) {
            if (this.localItem.children && this.localItem[referer] === null) {
                const activeChildren = this.localItem.children.filter(child => {
                    return child[referer] === 1;
                });
                return activeChildren.length > 0;
            }
            return false;
        },
        outputRight(referer) {
            const value = this.handleRights(referer);
            if (value === 1) {
                return "check";
            } else if (value === 0) {
                return "times";
            } else {
                return "arrow-up";
            }
        },
        handleRights(referer) {
            if (this.parent) {
                if (this.localItem[referer] === null) {
                    const right = this.parent[referer];
                    return right;
                }
            }
            return this.localItem[referer];
        },
        handleParent() {
            const cLocalItem = { ...this.localItem };
            if (this.parent) {
                this.checkboxValues.forEach(referer => {
                    if (cLocalItem[referer] === null) {
                        cLocalItem[referer] = this.parent[referer];
                    }
                });
            }
            return cLocalItem;
        },
        update(child) {
            if (this.localItem.children) {
                const changedIndex = this.localItem.children.findIndex(
                    item => item.id === child.id
                );
                this.localItem.children[changedIndex] = child;
                this.$emit("update", this.localItem);
            }
        }
    }
};
</script>